module.exports = __webpack_public_path__ + "static/media/hero_partner_comparison.bb7285ca.svg";